import Localbase from 'localbase';

const db = () => new Localbase('parvisio-itinerant');

export default db;
